import React from 'react';
import { FileModel } from '../Types/FileModel';

interface FileListProps {
  title: string;
  items: FileListItem[];
}

interface FileListItem {
  name: string;
  file: FileModel;
  fileSize: string;
}

const FileListBlock = (props: FileListProps) => {
  const { title, items } = props;

  if (items.length <= 0) return;

  return (
    <div className="flex flex-col rounded-lg bg-gray-100 p-6">
      {title && (
        <h2 className="pb-2 font-normal text-gray-700">{title}</h2>
      )}
      <ul className="px-4">
        {items.map(({ name, file, fileSize }, index) => {
          return (
            <li className="list-disc pb-2 last:pb-0" key={index}>
              <a
                className="text-xl font-light leading-normal text-gray-700"
                href={file.url}
              >
                <span className="underline">{name ?? file.filename}</span>
                {fileSize && (
                  <span className="text-md text-gray-500">
                    {' '}
                    ({fileSize})
                  </span>
                )}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FileListBlock;
